<template>
  <el-table-column
    v-bind="$attrs"
    :label="label"
    align="center"
    class-name="member-field"
    >
    <template slot-scope="scope">
      <el-popover
        trigger="hover"
        >
        <el-table
          :data="getData(scope.row)"
          :show-header="false"
          row-class-name="popover-field"
          >
          <el-table-column
            prop="icon"
            width="35"
            align="center"
            >
            <template slot-scope="scope">
              <div
                v-if="scope.row.icon === 'uid'"
                >
                ID
              </div>
              <div v-else-if="scope.row.icon === 'user'">
                <svg-icon icon-class="baseline-person-24px"></svg-icon>
              </div>
              <div v-else-if="scope.row.icon === 'authType'">
                <i class="el-icon-s-check"></i>
              </div>
              <div v-else-if="scope.row.icon === 'nickname'">
                <i class="el-icon-user"></i>
              </div>
              <div v-else-if="scope.row.icon === 'email'">
                <i class="el-icon-message"></i>
              </div>
              <div v-else-if="scope.row.icon === 'phone'">
                <i class="el-icon-phone"></i>
              </div>
              <div v-else-if="scope.row.icon === 'os'">
                <i class="el-icon-mobile-phone"></i>
              </div>
              <el-image
                v-else-if="scope.row.icon === 'brand'"
                class="brand-icon"
                :src="getBrandIcon(scope.row.brand_id)"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            width="250"
            prop="data"
            >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top-start"
                :disabled="!(scope.row.icon === 'uid' &&
                  scope.row.unhideID &&
                  scope.row.unhideID !== scope.row.data)"
                >
                <div
                  slot="content"
                  class="tool-tip-content allow-click-copy"
                  @click="doCopy(scope.row.unhideID)"
                  >
                  {{ getLabelText('user', 'unhide_uid') }}: {{ scope.row.unhideID }}
                </div>
                <div
                  class="allow-click-copy"
                  @click="doCopy(scope.row.data)"
                  >
                  {{ scope.row.data }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="tool-tip-content">
          <el-button
            v-if="scope.row.uid"
            size="mini"
            type="primary"
            icon="el-icon-search"
            circle
            @click="doSearch('uid', scope.row.uid)"
            >
          </el-button>
          <el-button
            v-else-if="scope.row.member_funbook_id"
            size="mini"
            type="primary"
            icon="el-icon-search"
            circle
            @click="doSearch('member_funbook_id', scope.row.member_funbook_id)"
            >
          </el-button>
          <el-button
            v-if="scope.row.uid"
            size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="doEdit(scope.row.uid, scope.row.brand_id)"
            >
          </el-button>
          <el-tooltip
            v-if="isVIP(scope.row.member_level)"
            >
            <div slot="content">{{ scope.row.member_level_name }}</div>
            <el-button
              size="mini"
              class="no-click"
              :class="getMemberPopOverBtnClass(scope.row.member_level)"
              circle
              >
              <svg-icon
                :class="getMemberIconClass(scope.row.member_level)"
                :icon-class="getMemberIcon(scope.row.member_level)"
              >
              </svg-icon>
            </el-button>
          </el-tooltip>
          <el-tooltip
            v-if="!$_isMemberEnabled(scope.row)"
            >
            <div slot="content">
              {{ $t('api.user.status.banned') }}
              ({{ getStatus(scope.row.member_status)}})
            </div>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-remove"
              class="no-click"
              circle
              >
            </el-button>
          </el-tooltip>
        </div>
        <el-badge
          slot="reference"
          :hidden="typeof scope.row.cust_num === 'undefined' || isFunBook"
          :value="scope.row.cust_num"
          type="primary"
          >
          <el-button
            :type="$_getMemberButtonType(scope.row)"
            :class="getMemberIconBtnClass(scope.row.member_level)"
            circle
            >
            <svg-icon
              :class="getMemberIconClass(scope.row.member_level)"
              :icon-class="getMemberIcon(scope.row.member_level)"
            >
            </svg-icon>
          </el-button>
        </el-badge>
      </el-popover>
    </template>
  </el-table-column>
</template>

<script>

import { doCopy } from '@/utils/copy'
import { updateRoute } from '@/utils/route'
import { isVIP } from '@/utils/member_level'
import { getMap, getLabelText } from '@/utils/i18n'
import Enums from '@/mixins/enums'
import { BrandIcon, MemberLevelIcon } from '@/enums'

export default {
  mixins: [Enums],
  name: 'member-field',
  props: {
    value: null,
    base: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'member'
    },
    name: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
    isFunBook () {
      return this.type === 'funbook'
    },
    label () {
      return this.$t('api.member.label')
    }
  },
  methods: {
    doCopy,
    updateRoute,
    getMap,
    getLabelText,
    isVIP,
    getBrandIcon (id) {
      return BrandIcon[id]
    },
    getMemberIcon (lv) {
      if (this.isVIP(lv)) {
        return MemberLevelIcon[lv]
      }
      return 'baseline-person-24px'
    },
    getMemberPopOverBtnClass (lv) {
      if (this.isVIP(lv)) {
        return 'member-lv-btn member-lv-popover-btn'
      }
      return ''
    },
    getMemberIconClass (lv) {
      if (this.isVIP(lv)) {
        return 'member-lv-icon'
      }
      return ''
    },
    getMemberIconBtnClass (lv) {
      if (this.isVIP(lv)) {
        return 'member-lv-btn member-lv-popover-btn'
      }
      return ''
    },
    getIconClass (id) {
      if (typeof id !== 'undefined' && id !== 0) {
        return 'diamond'
      }
      return 'baseline-person-24px'
    },
    getStatus (status) {
      let s = this.getMap('status', 'member').filter(function (el) {
        return el.value === status
      })
      return (s[0]) ? s[0].label : ''
    },
    getData (data) {
      if (this.isFunBook || data.auth_type === 10) {
        let arr = [{
          icon: 'nickname',
          data: data['nickname']
        }, {
          icon: 'email',
          data: data['email']
        }, {
          icon: 'phone',
          data: data['contact_phone'] || data['phone']
        }]

        if (data['uid'] && data['auth_type'] !== 10) {
          arr.splice(1, 0, {
            icon: 'user',
            data: data['uid'],
            unhideID: data['unhide_uid']
          })
        }
        return arr
      }
      let authType = this.getMap('authType').filter(function (el) {
        return el.value === data['auth_type']
      })
      let d = [{
        icon: 'uid',
        data: data['uid'],
        unhideID: data['unhide_uid']
      }, {
        icon: 'user',
        data: data['auth_id']
      }, {
        icon: 'authType',
        data: (authType[0]) ? authType[0].label : ''
      }, {
        icon: 'nickname',
        data: data['nickname']
      }, {
        icon: 'email',
        data: data['email']
      }, {
        icon: 'phone',
        data: data['contact_phone'] || data['phone']
      }]
      if (data['os']) {
        d.push({
          icon: 'os',
          data: data['os']
        })
      }
      d.push({
        icon: 'brand',
        data: data['brand_name'],
        brand_id: data['brand_id']
      })
      return d
    },
    doEdit (uid, brandID) {
      let path = '/user/member/funnow/edit/' + uid
      switch (brandID) {
        case 2:
          path = '/user/member/niceday/edit/' + uid
          break
        case 3:
          path = '/user/member/eatigo/edit/' + uid
          break
      }
      this.$router.push({
        path: path
      })
    },
    doSearch (field, q) {
      this.updateRoute([{
        'field': field,
        'value': q
      }])
    }
  }
}
</script>

<style scoped>
.member-field .el-button.is-circle.member-lv-btn {
  padding: 0;
}

.member-lv-popover-btn {
  padding: 0;
  vertical-align: bottom;
}

.member-lv-icon {
  width: 28px;
  height: 28px;
}
</style>
